import type { MapServiceContractResponse } from "@/features/map/types";

/**
 * 地図サービス契約情報をlocalStorageに保存する
 * @param contract 地図サービス契約情報（nullの場合は全て削除）
 */
export const saveMapServiceContractToLocalStorage = (
  contract: MapServiceContractResponse | null
): void => {
  // GEOSPACE契約情報の保存
  const geospaceKeys = [
    { key: "mapServiceAppId", value: contract?.geospace?.appId ?? null },
    {
      key: "mapServiceTrialStartDate",
      value: contract?.geospace?.trialStartDate ?? null,
    },
    {
      key: "mapServiceTrialEndDate",
      value: contract?.geospace?.trialEndDate ?? null,
    },
    {
      key: "mapServiceContractStartDate",
      value: contract?.geospace?.contractStartDate ?? null,
    },
    {
      key: "mapServiceContractEndDate",
      value: contract?.geospace?.contractEndDate ?? null,
    },
  ];

  geospaceKeys.forEach(({ key, value }) => {
    if (contract?.geospace && value !== null) {
      localStorage.setItem(key, value);
    } else {
      localStorage.removeItem(key);
    }
  });

  // ZENRIN契約情報の保存
  const zenrinKeys = [
    {
      key: "mapZenrinContractStartDate",
      value: contract?.zenrin?.contractStartDate ?? null,
    },
    {
      key: "mapZenrinContractEndDate",
      value: contract?.zenrin?.contractEndDate ?? null,
    },
    {
      key: "mapZenrinTrialStartDate",
      value: contract?.zenrin?.trialStartDate ?? null,
    },
    {
      key: "mapZenrinTrialEndDate",
      value: contract?.zenrin?.trialEndDate ?? null,
    },
  ];

  zenrinKeys.forEach(({ key, value }) => {
    if (contract?.zenrin && value !== null) {
      localStorage.setItem(key, value);
    } else {
      localStorage.removeItem(key);
    }
  });
};
